import { Button, Spin, Typography } from "antd";
import { LoginOutlined } from "@ant-design/icons";

import { useAuth } from "context/AuthContext";
import CubesLogo from "assets/cubes.png";
import MARSLogo from "assets/mars.png";
import QuarticaLogo from "assets/quartica.png";

const { Title, Text } = Typography;

const backgroundStyle = {
  background: "linear-gradient(135deg, #12357f 0%, #1c5eb5 45%, #14b8d4 100%)"
};

/**
 * Full-screen gate shown until Azure AD sign-in completes, mirroring the
 * `rmp` app's AuthBackgroundScreen. Login is attempted automatically (see
 * AuthContext), but a manual "Sign in" button is also provided in case the
 * popup was blocked or the user needs to retry.
 */
const AuthBackgroundScreen = ({ accessDenied = false }) => {
  const { login, isAuthenticating, authError, appAccessDenied, isMsalConfigured } = useAuth();

  const message = accessDenied ? appAccessDenied?.message : authError;

  return (
    <div style={{ height: "100vh", width: "100vw", position: "relative", overflow: "hidden", ...backgroundStyle }}>
      <div style={{ position: "absolute", top: 40, left: 60, display: "flex", alignItems: "center", gap: 14 }}>
        <img src={CubesLogo} alt="MARS" style={{ height: 46, width: "auto" }} />
        <img src={MARSLogo} alt="MARS Document Builder" style={{ height: 34, width: "auto" }} />
      </div>

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "rgba(0,0,0,0.45)",
          border: "1px solid rgba(255,255,255,0.3)",
          borderRadius: 12,
          padding: "40px 48px",
          maxWidth: 460,
          textAlign: "center"
        }}
      >
        <Title level={3} style={{ color: "#fff", marginBottom: 8 }}>
          MARS Document Builder
        </Title>
        <Text style={{ color: "rgba(255,255,255,0.85)", display: "block", marginBottom: 24 }}>Sign in with your Quartica Microsoft account to continue.</Text>

        {accessDenied ? (
          <>
            <div style={{ fontSize: 36, marginBottom: 12 }}>🚫</div>
            <Text style={{ color: "#ffffff", fontSize: 16, fontWeight: 600, display: "block", marginBottom: 8 }}>Access Denied</Text>
            <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 13, display: "block" }}>{message}</Text>
          </>
        ) : (
          <>
            {isAuthenticating ? (
              <Spin tip="Signing you in..." size="large" />
            ) : (
              <Button type="primary" size="large" icon={<LoginOutlined />} onClick={login} disabled={!isMsalConfigured}>
                Sign in with Microsoft
              </Button>
            )}
            {message && (
              <Text type="warning" style={{ display: "block", marginTop: 16, fontSize: 12 }}>
                {message}
              </Text>
            )}
            {!isMsalConfigured && (
              <Text style={{ display: "block", marginTop: 16, color: "rgba(255,255,255,0.7)", fontSize: 12 }}>
                SSO is not configured. Add clientId/authority in public/config.js.
              </Text>
            )}
          </>
        )}
      </div>

      <div style={{ position: "absolute", bottom: 44, left: "50%", transform: "translateX(-50%)", textAlign: "center", color: "#fff" }}>
        <Text style={{ color: "#ffffff", fontSize: 13 }}>Copyright © 2026 by Quartica. All Rights Reserved</Text>
        <div style={{ marginTop: 8 }}>
          <img src={QuarticaLogo} alt="Quartica" style={{ height: 24, width: "auto" }} />
        </div>
      </div>
    </div>
  );
};

export default AuthBackgroundScreen;
